<script setup>
import { ref, computed } from 'vue'
import * as z from 'zod'
import { toTypedSchema } from '@/lib/zodTypedSchema'
import { HOST, API } from '@/utils/http'

import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { toast } from '@/components/ui/toast'
import { Spinner } from '@/components/ui/spinner'

const emit = defineEmits(['formSubmitted'])
const props = defineProps({
  orgId: {
    type: String,
    required: true
  },
  feature: {
    type: Object,
    required: false
  },
  name: {
    type: String,
    required: true
  }
})
const isSubmitting = ref(false)

const formSchema = toTypedSchema(z.object({
}))

const postLayer = async (layer) => {
  try {
    const response = await API({
      method: 'POST',
      url: `${HOST}/org/${props.orgId}/layers`,
      data: layer
    })

    toast({ title: 'Layer created successfully' })
    emit('formSubmitted', response.data)
  } catch (error) {
    console.error(error)
  }
}

const onSubmit = async (values) => {
  isSubmitting.value = true

  const layer = {
    org_id: parseInt(props.orgId),
    type: 4,
    name: props.name,
    layer: {
      aoi: props.feature?.geometry ? props.feature.geometry : null,
      data: {
        filter: {
          type: "AndFilter",
          config: []
        }
      }
    }
  }

  await postLayer(layer)
  try {
    console.log(values)
    isSubmitting.value = false
  } catch (error) {
    console.error(error)
    toast({ title: 'Error creating radar layer', status: 'error' })
    isSubmitting.value = false
  }
}
</script>

<template>
  <Form class="space-y-4 mt-4" :validation-schema="formSchema" @submit="onSubmit">

    <div class="flex justify-end">
      <Button type="submit" :disabled="isSubmitting">
        <Spinner v-if="isSubmitting" class="w-4 h-4" />
        <span v-else>Add Data Layer</span>
      </Button>
    </div>
  </Form>
</template>
